// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/purple.scss
// module id = 592
// module chunks = 376